import { render, staticRenderFns } from "./BlockPersonalInformation.vue?vue&type=template&id=b6fc47e0&"
import script from "./BlockPersonalInformation.vue?vue&type=script&lang=ts&"
export * from "./BlockPersonalInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports